(() => {
  function mount(el) {
    if(el.dataset.ready) return;
    el.dataset.ready='true';
    const q=s=>el.querySelector(s), qa=s=>[...el.querySelectorAll(s)];
    const data=JSON.parse(q('[data-product-data]').textContent);
    const currency=data.currency||'USD';
    const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency}).format(n/100);
    const packs=data.products, current=packs[data.current];
    const selected=[data.current,data.current];
    const canSubscribe=p=>p.available && p.plan && p.id;
    let sub=false, quantity=1, busy=false, slide=0;
    const fizz=q('[data-fizz]');
    const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
    let galleryVisible=false;
    function syncMotion(){
      if(!fizz)return;
      const running=!reducedMotion.matches&&galleryVisible&&slide===0&&!document.hidden;
      fizz.classList.toggle('is-running',running);
    }
    if(fizz){
      reducedMotion.addEventListener('change',syncMotion);
      document.addEventListener('visibilitychange',syncMotion);
      new IntersectionObserver(entries=>{galleryVisible=entries[0].isIntersecting;syncMotion();},{threshold:0.1}).observe(fizz);
    }
    const put=(s,t)=>{q(s).textContent=t;};
    function showSlide(i) {
      const slides=qa('[data-slide]'); slide=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>s.hidden=n!==slide);
      qa('[data-thumb]').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===slide)));
      put('[data-counter]',`${slide+1} / ${slides.length}`);
      const full=q('[data-gallery-full]');
      if(full) full.href=slides[slide].dataset.fullImage;
      syncMotion();
    }
    qa('[data-thumb]').forEach(b=>b.addEventListener('click',()=>showSlide(+b.dataset.thumb)));
    q('[data-prev]').addEventListener('click',()=>showSlide(slide-1));
    q('[data-next]').addEventListener('click',()=>showSlide(slide+1));
    q('.vp-slides').addEventListener('keydown',ev=>{
      if(ev.key==='ArrowRight'||ev.key==='ArrowLeft'){ev.preventDefault();showSlide(slide+(ev.key==='ArrowRight'?1:-1));}
    });
    let touchX;
    q('.vp-slides').addEventListener('touchstart',ev=>{touchX=ev.changedTouches[0].clientX;},{passive:true});
    q('.vp-slides').addEventListener('touchend',ev=>{const dx=ev.changedTouches[0].clientX-touchX;if(Math.abs(dx)>70)showSlide(slide+(dx<0?1:-1));},{passive:true});
    q('[data-sub-option]').hidden=!canSubscribe(current);
    qa('[data-pick]').forEach((select,n)=>{
      packs.forEach((p,i)=>{const opt=new Option(p.name,String(i),false,i===data.current);opt.disabled=!canSubscribe(p);select.add(opt);});
      select.addEventListener('change',()=>{selected[n]=+select.value;render();});
    });
    function render() {
      const chosen=selected.map(i=>packs[i]);
      const total=sub?chosen.reduce((n,p)=>n+(p.plan?.price||0),0):current.price*quantity;
      const valid=sub?chosen.every(canSubscribe):current.available&&current.id;
      q('[data-once-details]').hidden=sub;q('[data-sub-details]').hidden=!sub;
      put('[data-once-price]',money(current.price));
      
      if(chosen.every(canSubscribe)){
        const cost=chosen.reduce((n,p)=>n+p.plan.price,0);
        const saving=chosen.reduce((n,p)=>n+p.price,0)-cost;
        put('[data-sub-total]',money(cost));
        put('[data-sub-card-total]',money(cost));
        put('[data-sub-first]',money(Math.max(0,cost-2000)));
        put('[data-saving]',saving>0?`Save ${money(saving).replace('.00','')} a delivery.`:'');
      }
      put('[data-total]',money(sub?Math.max(0,total-2000):total));
      put('[data-atc-label]',!valid?'Currently unavailable':sub?'Subscribe':'Add to cart');
      put('[data-shipping]',total>=5000?'Free US shipping on orders $50+ after discounts.':'$3.99 US shipping. Free at $50 after discounts.');
      q('[data-atc]').disabled=busy||!valid;
      q('[data-quantity]').value=quantity;
      q('[data-status]').textContent='';
    }
    qa('input[name="vp-purchase"]').forEach(r=>r.addEventListener('change',()=>{sub=r.value==='sub';render();}));
    q('[data-pack-count]').addEventListener('change',ev=>{quantity=+ev.target.value;render();});
    q('[data-product-form]').addEventListener('submit',async ev=>{
      ev.preventDefault();if(busy)return;
      const chosen=selected.map(i=>packs[i]);
      if(sub&&!chosen.every(canSubscribe))return;
      if(!sub&&!current.available)return;
      const total=sub?chosen.reduce((n,p)=>n+p.plan.price,0):current.price*quantity;
      if(data.preview){
        put('[data-status]',sub?`Preview: ${chosen.map(p=>p.name+' 12-pack').join(' + ')}. ${money(total)} every 4 weeks, plus tax. Free shipping. Nothing has been added to your live cart.`:`Preview: ${quantity} ${current.name} 12-pack${quantity>1?'s':''}. ${money(total)}, plus tax${total<5000?' and $3.99 US shipping':'. Free US shipping'}. Nothing has been added to your live cart.`);
        return;
      }
      busy=true;render();q('[data-atc]').setAttribute('aria-busy','true');put('[data-atc-label]','Adding…');
      const items=sub?chosen.map(p=>({id:p.id,quantity:1,selling_plan:p.plan.id,properties:{'Recurring price':`${money(p.plan.price)} per 12-pack every 4 weeks, plus tax`}})):[{id:current.id,quantity}];
      try{
        const root=window.Shopify?.routes?.root||'/';
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await res.json();if(!res.ok)throw new Error(result.description||'Could not add your selection. Please try again.');
        window.location.assign(sub?root+'discount/VYVZYEPHBN?redirect='+encodeURIComponent(root+'cart'):root+'cart');
      }catch(err){busy=false;render();put('[data-status]',err.message||'Could not add your selection. Please try again.');q('[data-atc]').removeAttribute('aria-busy');}
    });
    window.addEventListener('pageshow',ev=>{if(ev.persisted){busy=false;render();q('[data-atc]').removeAttribute('aria-busy');}});
    showSlide(0);
    render();
  }
  const boot=()=>{
    document.querySelectorAll('[data-vyv-product]').forEach(mount);
    document.querySelectorAll('[data-play-interview]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',()=>{const video=button.closest('.vp-athlete').querySelector('[data-athlete-video]');video.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});video.play().catch(()=>video.focus());});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
